var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcademic = function SvgAcademic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 74.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M28 24.4V44c0 6.8 17.7 12.3 39.6 12.3s39.6-5.5 39.6-12.3V24.4",
    className: "academic_svg__raw"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M2 16.4 67.6 2 133 16.4 67.7 34.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.26,
    d: "M85.1 30.3v28.6M89.4 73.8H81l.9-11.1c.1-1.7 1.6-3.1 3.3-3.1h0c1.7 0 3.2 1.3 3.3 3.1z"
  })));
};
export default SvgAcademic;